<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card tab2-card">
        <div class="card-header">
          <div class="form-group row">
            <div class="col-xl-3 col-md-3">
              <h5> Date identificare</h5>
            </div>
          </div>
          <div *ngIf="!invitedUser && validatedAndAdminRoleAssigned" class="form-group row">
            <button type="button" class="btn btn-primary" (click)="openInvitations()">
              Trimite invitatie
            </button>
          </div>
        </div>
        <div class="card-body tab2-card">
          <form [formGroup]="supplierForm" class="needs-validation" novalidate>
            <ng-container *ngIf="false">
              <div class="form-group row">
                <div class="col-xl-3 col-md-3">
                  <label>CUI<span>*</span></label>
                  <input class="form-control" type="text" formControlName="cui" required disabled>
                </div>
                <div class="col-xl-3 col-md-3 button-div">
                  <button type="button" class="btn btn-primary" disabled>Interogare RECOM</button>
                </div>
              </div>
              <br>
            </ng-container>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>Denumire<span>*</span></label>
                <input class="form-control" type="text" formControlName="name" />
                <div *ngIf="supplierForm.controls['name'].errors &&  (supplierForm.dirty || supplierForm.touched)"
                  class="text text-danger">
                  Nume companie obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Forma juridica<span>*</span></label>
                <select class="form-control digits" formControlName="legalForm">
                  <option>Societate pe acţiuni (SA)</option>
                  <option>Societate cu răspundere limitată (SRL)</option>
                  <option>Persoană fizică autorizată (PFA)</option>
                  <option>Regie autonoma (RA)</option>
                  <option>Institutie publica</option>
                  <option>Societate în nume colectiv</option>
                  <option>Societate în comandită simplă</option>
                  <option>Societate în comandită pe acţiuni</option>
                  <option>Întreprindere individuală (ÎI)</option>
                  <option>Întreprindere familială (ÎF)</option>
                  <option>Altele</option>
                </select>
                <div *ngIf="supplierForm.controls['legalForm'].errors &&  (supplierForm.dirty || supplierForm.touched)"
                  class="text text-danger">
                  Forma juridica obligatorie
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>CUI<span>*</span></label>
                <input class="form-control" type="text" formControlName="cui" />
                <div *ngIf="supplierForm.controls['cui'].errors &&  (supplierForm.dirty || supplierForm.touched)"
                  class="text text-danger">
                  CUI sau invalid
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Nr. inregistrare la ONRC<span>*</span></label>
                <input class="form-control" type="text" formControlName="onrcRegistrationNumber" />
                <div
                  *ngIf="supplierForm.controls['onrcRegistrationNumber'].errors &&  (supplierForm.dirty || supplierForm.touched)"
                  class="text text-danger">
                  Numar inregistrare ONRC obligatoriu
                </div>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>Telefon</label>
                <input class="form-control" type="text" formControlName="phoneNumber" />
                <div
                  *ngIf="supplierForm.controls['phoneNumber'].errors &&  (supplierForm.dirty || supplierForm.touched)"
                  class="text text-danger">
                  Numarul de telefon contine caractere invalide.
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Mobil</label>
                <input class="form-control" type="text" formControlName="mobileNumber" />
                <div
                  *ngIf="supplierForm.controls['mobileNumber'].errors &&  (supplierForm.dirty || supplierForm.touched)"
                  class="text text-danger">
                  Numarul de telefon mobil contine caractere invalide.
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Fax</label>
                <input class="form-control" type="text" formControlName="fax" />
                <div *ngIf="supplierForm.controls['fax'].errors &&  (supplierForm.dirty || supplierForm.touched)"
                  class="text text-danger">
                  Numarul de fax contine caractere invalide.
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Email</label>
                <input class="form-control" type="text" formControlName="email" />
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <h4> Date licenta</h4>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-3 col-sm-3 mb-0">
                <label>Numar licenta gaz</label>
                <input class="form-control" type="text" formControlName="licenseGas" />
              </div>
              <div class="col-xl-3 col-sm-3 mb-0">
                <label>Numar licenta electricitate</label>
                <input class="form-control" type="text" formControlName="licenseElectricity" />
              </div>
            </div>
            <div
              *ngIf="!(supplierForm.controls['licenseElectricity'].value || supplierForm.controls['licenseGas'].value) && (supplierForm.dirty || supplierForm.touched)"
              class="text text-danger">
              Licenta obligatorie
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <h4> Adresa sediu social</h4>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-sm-3 mb-0">
                <label>Judet<span>*</span></label>
                <select class="form-control digits" formControlName="county" (change)="onChangeCounty()">
                  <option *ngFor="let county of counties" [value]="county.id">
                    {{ county.name }} </option>
                </select>
                <div *ngIf="supplierForm.controls['county'].errors &&  (supplierForm.dirty || supplierForm.touched)"
                  class="text text-danger">
                  Judetul sediului social este obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-sm-3 mb-0">
                <label>Localitate<span>*</span></label>
                <select class="form-control digits" formControlName="city">
                  <option *ngFor="let city of cities" [value]="city.id">
                    {{ city.name }} </option>
                </select>
                <div *ngIf="supplierForm.controls['city'].errors &&  (supplierForm.dirty || supplierForm.touched)"
                  class="text text-danger">
                  Orasul sediului social este obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Strada<span>*</span></label>
                <input class="form-control" type="text" formControlName="streetName" />
                <div *ngIf="supplierForm.controls['streetName'].errors &&  (supplierForm.dirty || supplierForm.touched)"
                  class="text text-danger">
                  Numele strazii sediului social este obligatorie
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Numar<span>*</span></label>
                <input class="form-control" type="text" formControlName="streetNumber" />
                <div
                  *ngIf="supplierForm.controls['streetNumber'].errors &&  (supplierForm.dirty || supplierForm.touched)"
                  class="text text-danger">
                  Numarul strazii sediului social este obligatorie
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>Bloc</label>
                <input class="form-control" type="text" formControlName="block" />
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Etaj</label>
                <input class="form-control" type="text" formControlName="floor" />
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Apartament</label>
                <input class="form-control" type="text" formControlName="apartment" />
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Cod postal<span>*</span></label>
                <input class="form-control" type="text" formControlName="postalCode" />
                <div *ngIf="supplierForm.controls['postalCode'].errors &&  (supplierForm.dirty || supplierForm.touched)"
                  class="text text-danger">
                  Codul postal al sediului social este obligatoriu.
                </div>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <span class="bold"> Adresa de corespondență</span>
              </div>
              <div class="col-xl-3 col-md-3">
                <label class="d-block" for="chk-ani">
                  <input class="checkbox_animated" id="chk-ani" type="checkbox" (click)="toggleSameAddress()"
                    formControlName="sameAddress" [checked]="isSameAddress">
                  Aceeasi cu adresa sediului social
                </label>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-sm-3 mb-0">
                <label>Judet<span>*</span></label>
                <select class="form-control digits" formControlName="correspondenceCounty"
                  (change)="onChangeCountyCorrespondence()">
                  <option *ngFor="let county of counties" [value]="county.id">
                    {{ county.name }} </option>
                </select>
                <div
                  *ngIf="supplierForm.controls['correspondenceCounty'].errors &&  (supplierForm.dirty || supplierForm.touched)"
                  class="text text-danger">
                  Judetul adresei de corespondenta este obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-sm-3 mb-0">
                <label>Localitate<span>*</span></label>
                <select class="form-control digits" formControlName="correspondenceCity">
                  <option *ngFor="let city of citiesCorrespondence" [value]="city.id">
                    {{ city.name }} </option>
                </select>
                <div
                  *ngIf="supplierForm.controls['correspondenceCity'].errors &&  (supplierForm.dirty || supplierForm.touched)"
                  class="text text-danger">
                  Judetul adresei de corespondenta este obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Strada<span>*</span></label>
                <input class="form-control" type="text" formControlName="correspondenceStreetName" />
                <div
                  *ngIf="supplierForm.controls['correspondenceStreetName'].errors &&  (supplierForm.dirty || supplierForm.touched)"
                  class="text text-danger">
                  Numele strazii adresei de corespondenta este obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Numar<span>*</span></label>
                <input class="form-control" type="text" formControlName="correspondenceStreetNumber" />
                <div
                  *ngIf="supplierForm.controls['correspondenceStreetNumber'].errors &&  (supplierForm.dirty || supplierForm.touched)"
                  class="text text-danger">
                  Numarul strazii adresei de corespondenta este obligatoriu
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>Bloc</label>
                <input class="form-control" type="text" formControlName="correspondenceBlock" />
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Etaj</label>
                <input class="form-control" type="text" formControlName="correspondenceFloor" />
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Apartament</label>
                <input class="form-control" type="text" formControlName="correspondenceApartment" />
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Cod postal<span>*</span></label>
                <input class="form-control" type="text" formControlName="correspondencePostalCode" />
                <div
                  *ngIf="supplierForm.controls['correspondenceStreetNumber'].errors &&  (supplierForm.dirty || supplierForm.touched)"
                  class="text text-danger">
                  Codul postal al adresei de corespondenta este obligatoriu
                </div>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <h4>Date identificare persoana</h4>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>Nume<span>*</span></label>
                <input class="form-control" type="text" formControlName="firstName" />
                <div *ngIf="supplierForm.controls['firstName'].errors && (supplierForm.dirty || supplierForm.touched)"
                  class="text text-danger">
                  Nume este obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Prenume<span>*</span></label>
                <input class="form-control" type="text" formControlName="lastName" />
                <div *ngIf="supplierForm.controls['lastName'].errors && (supplierForm.dirty || supplierForm.touched)"
                  class="text text-danger">
                  Prenume este obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>CNP<span>*</span></label>
                <input class="form-control" type="text" formControlName="cnp" />
                <div *ngIf="supplierForm.controls['cnp'].errors && (supplierForm.dirty || supplierForm.touched)"
                  class="text text-danger">
                  CNP este obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Functie<span>*</span></label>
                <input class="form-control" type="text" formControlName="position" />
                <div *ngIf="supplierForm.controls['position'].errors && (supplierForm.dirty || supplierForm.touched)"
                  class="text text-danger">
                  Functia este obligatorie
                </div>
              </div>
            </div>
            <br>
            <ng-container *ngIf="!!invitedUser">
              <div class="form-group row">
                <div class="col-xl-3 col-md-3">
                  <label>Încărcare act de identitate
                    <a
                      href="https://github.com/posfgit/standard/blob/main/Proces%20de%20validare%20a%20datelor%20s%CC%A6i%20de%20aprobare%20a%20cererilor%20de%20conturi%20v2.pdf">
                      <i class="fa fa-info-circle" aria-hidden="true"></i></a>
                    <span>*</span></label>
                  <div *ngIf="!invitedDocument && isFormSubmitAttempt" class="text text-danger">
                    Vă rugăm încărcați fișierul
                  </div>
                </div>
                <div class="dropzone-custom col-xl-6 col-md-6">
                  <div class="dropzone dropzone-primary" appDragDropFileUpload (click)="fileField.click()"
                    (fileDropped)="upload($event)">
                    <div class="dz-message needsclick">
                      <i class="fa fa-cloud-upload"></i>
                      <h4 class="mb-0 f-w-600">Apăsați aici și selectați fișierul sau trage-l cu mouse-ul în aceași
                        zonă.</h4>
                      <br>
                      <h4 class="mb-0 f-w-600">Adăugați un fișier, document pdf sau imagine cu următoarele extensii:
                        .jpeg, .jpg, .png</h4>
                    </div>
                    <input type="file" name="avatars" multiple #fileField (change)="upload($any($event).target.files)"
                      hidden />
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-3 col-md-3">
                  <h4>Act de identitate</h4>
                </div>
              </div>
              <br>
              <div class="form-group row">
                <div class="col-xl-8 col-md-8">
                  <span class="font-weight-bold">Fisier</span>
                </div>
                <div class="col-xl-2 col-md-2">
                  <span class="font-weight-bold">Dimensiune</span>
                </div>
                <div class="col-xl-2 col-md-2">
                  <span class="font-weight-bold">Optiuni</span>
                </div>
              </div>
              <div class="form-group row" *ngIf="invitedDocument">
                <div class="col-xl-8 col-md-8">
                  <span>{{invitedDocument.fileName}}</span>
                </div>
                <div class="col-xl-2 col-md-2">
                  <span *ngIf="invitedDocument.fileByteSize">{{invitedDocument.fileByteSize | fileSize}}</span>
                </div>
                <div class="col-xl-2 col-md-2">
                  <a *ngIf="invitedDocument.file || invitedDocument.fileUrl" class="link pointer"
                    (click)="documentService.downloadDocument(invitedDocument)">Descarca</a>
                  <td><a class="link pointer" (click)="deleteDocument()">Sterge</a></td>
                </div>
              </div>
              <br>
            </ng-container>
            <ng-container *ngIf="!invitedUser">
              <div class="form-group row">
                <div class="col-xl-3 col-md-3">
                  <label>Încărcare documente justificative
                    <a
                      href="https://github.com/posfgit/standard/blob/main/Proces%20de%20validare%20a%20datelor%20s%CC%A6i%20de%20aprobare%20a%20cererilor%20de%20conturi%20v2.pdf">
                      <i class="fa fa-info-circle" aria-hidden="true"></i></a>
                    <span>*</span></label>
                  <div *ngIf="adminDocuments?.length === 0 && isFormSubmitAttempt" class="text text-danger">
                    Vă rugăm încărcați cel puțin un fișier
                  </div>
                </div>
                <div class="dropzone-custom col-xl-6 col-md-6">
                  <div [ngClass]="onDisplayRequiredAdminDocuments()" class="dropzone dropzone-primary"
                    appDragDropFileUpload (click)="editable ? fileField.click(): $event.preventDefault()"
                    (fileDropped)="upload($event)" [class.disabled]="!editable">
                    <div class="dz-message needsclick">
                      <i class="fa fa-cloud-upload"></i>
                      <h4 class="mb-0 f-w-600">Apăsați aici și selectați fișierul sau trage-l cu mouse-ul în aceași
                        zonă.</h4>
                      <br>
                      <h4 class="mb-0 f-w-600">Adăugați un fișier, document pdf sau imagine cu următoarele extensii:
                        .jpeg, .jpg, .png</h4>
                    </div>
                    <input type="file" name="avatars" multiple #fileField (change)="upload($any($event).target.files)"
                      hidden />
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-3 col-md-3">
                  <h4>Documente justificative</h4>
                </div>
              </div>
              <br>
              <div class="form-group row">
                <div class="col-xl-8 col-md-8">
                  <span class="font-weight-bold">Fisier</span>
                </div>
                <div class="col-xl-2 col-md-2">
                  <span class="font-weight-bold">Dimensiune</span>
                </div>
                <div class="col-xl-2 col-md-2">
                  <span class="font-weight-bold">Optiuni</span>
                </div>
              </div>
              <div class="form-group row" *ngFor="let document of adminDocuments; let ind = index">
                <div class="col-xl-8 col-md-8">
                  <span>{{document.fileName}}</span>
                </div>
                <div class="col-xl-2 col-md-2">
                  <span *ngIf="document.fileByteSize">{{document.fileByteSize | fileSize}}</span>
                </div>
                <div class="col-xl-2 col-md-2" [class.disabled]="!editable">
                  <a *ngIf="document.file || document.fileUrl" class="link pointer"
                    (click)="editable ? documentService.downloadDocument(document) : $event.preventDefault()">Descarca</a>
                  <td><a class="link pointer"
                      (click)="editable ? deleteDocument(ind) : $event.preventDefault()">Sterge</a></td>
                </div>
              </div>
              <br>
            </ng-container>
            <div class="form-group row mb-0 pull-right">
              <button type="button" class="btn btn-light button-margin" (click)="cancel()">Renunta</button>
              <ng-container [ngSwitch]="getCommitButtonTemplateName()">
                <ng-container *ngSwitchCase="'send'">
                  <button type="button" class="btn btn-primary mr-1 button-margin" (click)="saveSupplierDetails()">
                    Transmite spre validare
                  </button>
                </ng-container>
                <ng-container *ngSwitchCase="'pending'">
                  <button type="button" class="btn btn-primary mr-1 button-margin" disabled>
                    In curs de validare...
                  </button>
                </ng-container>
                <ng-container *ngSwitchCase="'save'">
                  <button type="button" class="btn btn-primary mr-1 button-margin" (click)="saveSupplierDetails()">
                    Salveaza
                  </button>
                </ng-container>
              </ng-container>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Container-fluid Ends-->